<template>
  <Navbar v-if="show1"/>
  <Navbarfa v-if="show2"/>
  <router-view/>
  <Footer v-if="show3"/>
  <Footerfa v-if="show4"/>
</template>

<script>
import { defineComponent } from '@vue/composition-api';
import Navbar from "./views/navbar.vue";
import Navbarfa from "./views/navbarfa.vue";
import Footer from "./views/footer.vue";
import Footerfa from "./views/footerfa.vue";
import { useRouter } from 'vue-router';
import { onMounted, ref } from 'vue';
import axois from 'axios';
  
export default defineComponent({
  components: { Navbar,Navbarfa, Footer, Footerfa },
  setup() {
    const router = useRouter()
    const show3 = ref()
    const show4 = ref()
    const show1 = ref()
    const show2 = ref()

    onMounted(()=>{
      localStorage.setItem('demo_token',
      'Bearer eyJhbGciOiJIUzI1NiIsImlzcyI6bnVsbCwidHlwIjoiSldUIn0.eyJ1c2VyX2lkIjo5NDEzNDAwMTEsImV4cCI6MTcyNjMwMzg3OH0.cAyYIV25_EcGFD4bnuLQGkBt_T4dSbjM7Bc-SwJFeUk')
      if (!localStorage.getItem('counter')) {
        localStorage.setItem('counter',0)
      }
      //if (window.location.pathname == '/product' || window.location.pathname == '/404/' || window.location.pathname.substring(0,15) == '/product-single' || window.location.pathname == '/sign-in/'
      //    || window.location.pathname == '/sign-out/'
      //) {
      //  show3.value = false;
      //}
      //else {
      //  show3.value = true;
      //}

      if (localStorage.getItem('lang') == null) {
        localStorage.setItem('lang','fa')
      }

      if (localStorage.getItem('lang')=='fa')
      {
        show1.value = false;
        show2.value = true;
        show3.value = false;
        show4.value = true;
        if (window.location.pathname == '/product' || window.location.pathname == '/404/' || window.location.pathname.substring(0,15) == '/product-single' || window.location.pathname == '/sign-in/'
          || window.location.pathname == '/sign-out/'
        ) {
          show3.value = false;
          show4.value = false;
        }
        //else {
        //  show3.value = true;
        //  show4.value = true;
        //}
        
      }
      if (localStorage.getItem('lang')=='en')
      {
        show2.value = false;
        show1.value = true;
        show4.value = false;
        show3.value = true;
      }

      
      axois.get(process.env.VUE_APP_BASE_URL+'products').then((res)=>{
        for (let i = 0; i < res.data.products.length; i++) {
          if (res.data.products[i].product2[0].maintext2) res.data.products[i].product2[0].maintext2=res.data.products[i].product2[0].maintext2.substring(3, res.data.products[i].product2[0].maintext2.length-6)
          if(res.data.products[i].maintext) res.data.products[i].maintext=res.data.products[i].maintext.substring(3, res.data.products[i].maintext.length-6)
          // res.data.products[0].pic = '../assets/img/product/bg-product.jpg'
        }
        localStorage.setItem('sliders', JSON.stringify(res.data.products))
        
      })
    })

    return {
      router,
      show3, 
      show4, 
      show1,
      show2
    }

  },
})
</script>
<style>

</style>
